import Config from './config.js';
import Alert from 'react-s-alert';
import moment from 'moment';
import Holidays from 'date-holidays'


export function isAdmin(){

  if (Config.api.getRole() === 'Administrator' || isAsimilatedByAdmin()){
    return true;
  }
  return false;
}

export function isAsimilatedByAdmin(){

    if (Config.api.getRole() === 'Administrator' || Config.api.getRoleOriginal()==="Administrator"){
        return true;
    }
    return false;
}

export function isStation() {
    if (Config.api.getRole() === 'Station') {
        return true;
    }
    return false;
}


export function isStationManager() {
    if (Config.api.getRole() === 'StationManager') {
        return true;
    }
    return false;
}

export function isWheelChanger(){
  if (Config.api.getRole() === 'WheelChanger'){
    return true;
  }
  return false;
}

export function isHarbour(){
  if (Config.api.getStationType() === 'Harbour'){
    return true;
  }
  return false;
}

export function isReturnStation(){
  if (Config.api.getRole() === 'ReturnStation'){
    return true;
  }
  return false;
}

export function notification(message){
    Alert.info(message);
    setTimeout(function(){ Alert.closeAll()}, 4000);
}

export function getPdfDataOrder(order){
  var headerBody = [
    [
      {
        text: 'Ordernummer: ' + order.id,
        style: 'header'
      },
      {
        // image: logotype,
        // style: {
        //   alignment: 'right',
        // }
      }
    ]
  ]

  var deliveryInfoBody = [
    [
      {
        text: 'Upphämtningsadress:',
        style: 'bold'
      },
      '',
      {
        text: 'Leveransadress:',
        style: 'bold'
      }
    ],
    [
      order.fromStationName + '\n' + order.fromAddress + '\n' + order.fromPostalCode + ' ' + order.fromCity,
      {
        // image: arrow,
        // width: 50,
        // height: 50,
        // style: {
        //   alignment: 'center'
        // }
      },
      order.toStationName + '\n' + order.toAddress + '\n' + order.toPostalCode + ' ' + order.toCity,
    ]
  ]

  var wheelsBody = []

  var wheelsColumns = [
    {
      text: 'Rad',
      style: 'tableHeader'
    },
    {
      text: 'Artikelnummer',
      style: 'tableHeader'
    },
    {
      text: 'Regnr',
      style: 'tableHeader'
    },
    {
      text: 'Beskrivning',
      style: 'tableHeader'
    },
    {
      text: 'Antal',
      style: 'tableHeader'
    }
  ]

  wheelsBody.push(wheelsColumns)
  order.ordersToPrint.forEach((order, index) => {
    var dataRow = []

    dataRow.push(index + 1);
    dataRow.push(order.regnr+((order.hjulmodell!=="Summer") ? "-W": ""));
    dataRow.push(order.regnr);
    dataRow.push(order.hjulmodell);
    dataRow.push('4');

    wheelsBody.push(dataRow)
  })

  var docDefinition = {
    header: (page, pages) => {
      return {
        text: [
          moment().format('YYYY-MM-DD') + '\n',
          'Sida: ' + page.toString() + ' av ' + pages
        ],
        alignment: 'right',
        style: 'pageHeader'
      }
    },
    content: [
      {
        table: {
          widths: ['*', '*'],
          body: headerBody
        },
        layout: 'noBorders'
      },
      {
        table: {
          widths: ['*', '*', '*'],
          body: deliveryInfoBody
        },
        layout: 'noBorders',
        style: 'deliveryInfo'
      },
      {
        text: 'Önskat leveransdatum:\n' + moment(order.desiredDate).format('YYYY-MM-DD'),
        style: 'returnDate'
      },
      {
        table: {
          widths: ['*', '*', '*', '*', '*'],
          body: wheelsBody
        },
        style: 'table'
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      table: {
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        // color: '#037b00',
        fillColor: '#d8d8d8'
      },
      deliveryInfo: {
        margin: [0, 20, 0, 20]
      },
      bold: {
        bold: true
      },
      returnDate: {
        margin: [350, 0, 0, 0],
        alignment: 'right'
      },
      pageHeader: {
        margin: [0, 10, 10, 0]
      }
    }
  }


  return docDefinition;
}

export function getPdfDataWheelChanger(wheelChanger){
  var headerBody = [[{
        text: `Ordernummer: ${wheelChanger.id}\nSändningsnummer: ${wheelChanger.shippingNo}`,
        style: 'header'}]];

  var deliveryInfoBody = [[
      {text: 'Upphämtningsadress:', style: 'bold'},
      '',
      {text: 'Leveransadress:', style: 'bold'}
    ],
    [
      wheelChanger.fromStationName + '\n' + wheelChanger.fromAddress + '\n' + wheelChanger.fromPostalCode + ' ' + wheelChanger.fromCity,
      {
        // image: arrow,
        // width: 50,
        // height: 50,
        // style: {
        //   alignment: 'center'
        // }
      },
      wheelChanger.toStationName + '\n' + wheelChanger.toAddress + '\n' + wheelChanger.toPostalCode + ' ' + wheelChanger.toCity,
    ]
  ]

  var wheelsBody = []

  var wheelsColumns = [
    {
      text: 'Rad',
      style: 'tableHeader'
    },
    {
      text: 'Artikelnummer',
      style: 'tableHeader'
    },
    {
      text: 'Regnr',
      style: 'tableHeader'
    },
    {
      text: 'Beskrivning',
      style: 'tableHeader'
    },
    {
      text: 'Antal',
      style: 'tableHeader'
    }
  ]

  wheelsBody.push(wheelsColumns)
  wheelChanger.selectedWheels.forEach((order, index) => {
    var dataRow = []
    var artNr =  order.wheeltype !== 'Summer' ? order.regNo + '-W' : order.regNo;

    dataRow.push(index + 1);
    dataRow.push(artNr);
    dataRow.push(order.regNo);
    dataRow.push(order.wheeltype);
    dataRow.push('4');

    wheelsBody.push(dataRow)
  })

  var docDefinition = {
    header: (page, pages) => {
      return {
        text: [
          moment().format('YYYY-MM-DD') + '\n',
          'Sida: ' + page.toString() + ' av ' + pages
        ],
        alignment: 'right',
        style: 'pageHeader'
      }
    },
    content: [
      {
        table: {
          widths: ['*', '*'],
          body: headerBody
        },
        layout: 'noBorders'
      },
      {
        table: {
          widths: ['*', '*', '*'],
          body: deliveryInfoBody
        },
        layout: 'noBorders',
        style: 'deliveryInfo'
      },
      {
        text: 'Returdatum:\n' + moment(wheelChanger.transitDate).format('YYYY-MM-DD'),
        style: 'returnDate'
      },
      {
        table: {
          widths: ['*', '*', '*', '*', '*'],
          body: wheelsBody
        },
        style: 'table'
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      table: {
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        // color: '#037b00',
        fillColor: '#d8d8d8'
      },
      deliveryInfo: {
        margin: [0, 20, 0, 20]
      },
      bold: {
        bold: true
      },
      returnDate: {
        margin: [350, 0, 0, 0],
        alignment: 'right'
      },
      pageHeader: {
        margin: [0, 10, 10, 0]
      }
    }
  }


  return docDefinition;
}



export function getPdfDataOutgoing(data){
  let docDefinition=[];



  var headerBody = [
    [
      {
        text: `Ordernummer: ${data.order.id}\nSändningsnummer: ${data.order.shippingNo}`,
        style: 'header'
      },
      {
        // image: logotype,
        // style: {
        //   alignment: 'right',
        // }
      }
    ]
  ]

  var deliveryInfoBody = [
    [
      {
        text: 'Upphämtningsadress:',
        style: 'bold'
      },
      '',
      {
        text: 'Leveransadress:',
        style: 'bold'
      }
    ],
    [
      data.fromContactInfo.name + '\n' + data.fromContactInfo.address + '\n' + data.fromContactInfo.postalCode + ' ' + data.fromContactInfo.city,
      {
        // image: arrow,
        // width: 50,
        // height: 50,
        // style: {
        //   alignment: 'center'
        // }
      },
      data.toContactInfo.name + '\n' + data.toContactInfo.address + '\n' + data.toContactInfo.postalCode + ' ' + data.toContactInfo.city
    ]
  ]

  var wheelsBody = []

  var wheelsColumns = [
    {
      text: 'Rad',
      style: 'tableHeader'
    },
    {
      text: 'Artikelnummer',
      style: 'tableHeader'
    },
    {
      text: 'Regnr',
      style: 'tableHeader'
    },
    {
      text: 'Beskrivning',
      style: 'tableHeader'
    },
    {
      text: 'Antal',
      style: 'tableHeader'
    }
  ]

  wheelsBody.push(wheelsColumns)
  data.order.wheelOrders.forEach((wheelOrder, index) => {
    var dataRow = []
    var artNr =  wheelOrder.wheel.wheeltype.name !== 'Summer' ? wheelOrder.wheel.regNo + '-W' : wheelOrder.wheel.regNo

    dataRow.push(index + 1)
    dataRow.push(artNr)
    dataRow.push(wheelOrder.wheel.regNo)
    dataRow.push(wheelOrder.wheel.wheeltype.name)
    dataRow.push('4')

    wheelsBody.push(dataRow)
  })

  docDefinition = {
    header: (page, pages) => {
      return {
        text: [
          moment().format('YYYY-MM-DD') + '\n',
          'Sida: ' + page.toString() + ' av ' + pages
        ],
        alignment: 'right',
        style: 'pageHeader'
      }
    },
    content: [
      {
        table: {
          widths: ['*', '*'],
          body: headerBody
        },
        layout: 'noBorders'
      },
      {
        table: {
          widths: ['*', '*', '*'],
          body: deliveryInfoBody
        },
        layout: 'noBorders',
        style: 'deliveryInfo'
      },
      {
        text: 'Returdatum\n' + moment(data.order.transitDate).format('YYYY-MM-DD'),
        style: 'returnDate'
      },
      {
        table: {
          widths: ['*', '*', '*', '*', '*'],
          body: wheelsBody
        },
        style: 'table'
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      table: {
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        // color: '#037b00',
        fillColor: '#d8d8d8'
      },
      deliveryInfo: {
        margin: [0, 20, 0, 20]
      },
      bold: {
        bold: true
      },
      returnDate: {
        margin: [350, 0, 0, 0],
        alignment: 'right'
      },
      pageHeader: {
        margin: [0, 10, 10, 0]
      }
    }
  }

  return docDefinition;
}


export function shouldRefresh(props,type){
  if (typeof(props.fetch[type])!=="undefined" && props.fetch[type]===true){
    return true;
  }
  return false;
}


export function getHolidays(){
    var holidays = new Holidays('SE');
    var holidaysArray = [];
    var currentYear = new Date().getFullYear();

    // Adds current years holidays to list
    holidays.getHolidays(currentYear).map(holiday => {
        if (holiday.type === "public"){
            return holidaysArray.push(holiday.date);
        } else if (holiday.name === "Julafton") {
            return holidaysArray.push(holiday.date);
        } else {
            return holidaysArray;
        }
    });

    // Adds next years holidays to list
    holidays.getHolidays(currentYear + 1).map(holiday => {
        if (holiday.type === "public"){
            return holidaysArray.push(holiday.date);
        } else if (holiday.name === "Julafton") {
            return holidaysArray.push(holiday.date);
        } else {
            return holidaysArray;
        }
    });

    return holidaysArray;
}

export function formatDate(date) {  
  if (!(date instanceof Date)) {
    throw new Error('Invalid "date" argument. You must pass a date instance')
  }
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}


// WEBPACK FOOTER //
// ./src/helpers.js